import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function createTopicClassifierSettings(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TOPIC_CLASSIFIER_ADD,
    (organisationId, topicId, classifierId) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/topic/${topicId}/classifier/${classifierId}`,
          {},
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
